import PropTypes from 'prop-types'
import { ResultHeader } from './result-header'
import { ResultVerifications } from './result-verifications'
import { ResultPendingDocuments } from './result-pending-documents'
import { ResultObservations } from './result-observations'

const buildContractLabel = (data) => (
  data?.contract_label || data?.contractLabel || [
    data?.contract_id ?? data?.contractId,
    data?.contract_name ?? data?.contractName
  ].filter(Boolean).join(' - ')
)

export const AccessResult = ({ result, children }) => {
  if (!result) return null

  return (
    <div className={`w-full ${result.access ? 'text-green-600' : 'text-red-600'}`}>
      <ResultHeader
        displayDoc={result.displayDoc}
        fullName={result.data?.display_name || result.data?.full_name}
        employeeRole={result.data?.employee_role_name}
        companyName={result.data?.company_name}
        contractLabel={buildContractLabel(result.data)}
        message={result.message}
      />
      <ResultVerifications verifications={result.detail?.verifications} />
      <ResultPendingDocuments documents={result.detail?.pending_documents} />
      <ResultObservations observations={result.observations} />
      {children}
    </div>
  )
}

AccessResult.propTypes = {
  result: PropTypes.shape({
    access: PropTypes.bool,
    displayDoc: PropTypes.string,
    message: PropTypes.string,
    observations: PropTypes.string,
    data: PropTypes.shape({
      display_name: PropTypes.string,
      full_name: PropTypes.string,
      employee_role_name: PropTypes.string,
      company_name: PropTypes.string,
      contract_label: PropTypes.string,
      contractLabel: PropTypes.string,
      contract_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      contractId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      contract_name: PropTypes.string,
      contractName: PropTypes.string
    }),
    detail: PropTypes.shape({
      verifications: PropTypes.arrayOf(PropTypes.object),
      pending_documents: PropTypes.arrayOf(PropTypes.object)
    })
  }),
  children: PropTypes.node
}

export {
  ResultHeader,
  ResultVerifications,
  ResultPendingDocuments,
  ResultObservations
}
